"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VocoUpload = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _hooks = require("../../hooks");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const holderStyle = {
  position: 'relative',
  display: 'inline-block',
  width: '100%',
  textAlign: 'center'
};
const buttonStyle = {
  pointerEvents: 'none'
};
const VocoUpload = _ref => {
  let {
    uploaded,
    mode,
    format,
    buttonClasses,
    buttonAttrs,
    caption,
    url,
    dimensions,
    schemeId
  } = _ref;
  const {
    upload,
    accept,
    isUploading,
    validationMessage
  } = (0, _hooks.useVocoUpload)({
    url,
    schemeId,
    uploaded,
    dimensions,
    mode,
    format
  });
  const onChange = e => {
    const file = e.target.files[0];

    // clearing file input
    e.target.value = null;
    upload(file);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    style: holderStyle
  }, /*#__PURE__*/_react.default.createElement("input", {
    onChange: onChange,
    type: "file",
    name: "file",
    accept: accept,
    disabled: isUploading,
    id: "upload-button-file",
    style: {
      display: 'none'
    }
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "upload-button-file"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: (buttonAttrs || {}).variant || 'contained',
    component: "span",
    color: (buttonAttrs || {}).color || 'primary',
    style: buttonStyle,
    className: buttonClasses
  }, isUploading ? 'Uploading...' : caption)), /*#__PURE__*/_react.default.createElement("span", null, validationMessage));
};
exports.VocoUpload = VocoUpload;